import React from "react";
import StarRating from "./StarRating";
import { formatPhoneDisplay, normalizePhoneDigits } from "../shared/utils/phoneFormat";
import { IconEdit, IconDuplicate, IconDelete, iconBtnStyle, RowActionIcons } from "../shared/icons/IconLib";

/**
 * Platform Vendor list card (accent bar, title, type, stars, phone/email, actions).
 * Used on Vendors page and peek overlays (e.g. Insurance → Vendor).
 */
export default function VendorEntityCard({
  vendor,
  selected = false,
  onSelectChange,
  showCheckbox = true,
  onTitleClick,
  onRatingChange,
  ratingReadOnly = false,
  onEdit,
  onDuplicate,
  onDelete,
  showActions = true,
}) {
  const v = vendor || {};
  const rating = v.rating >= 1 && v.rating <= 5 ? v.rating : 0;
  const phoneDigits = normalizePhoneDigits(v.phone);
  const title = v.name || "—";

  return (
    <div className="card">
      <div className="card-header">
        {showCheckbox ? (
          <input
            type="checkbox"
            checked={!!selected}
            onChange={(e) => onSelectChange && onSelectChange(e.target.checked)}
          />
        ) : null}
        <div className="card-header-content">
          {onTitleClick ? (
            <button type="button" className="btn-link card-title" onClick={onTitleClick}>
              {title}
            </button>
          ) : (
            <div className="btn-link card-title" style={{ cursor: "default", textDecoration: "none" }}>
              {title}
            </div>
          )}
          {v.type ? <div className="panel-hint">{v.type}</div> : null}
        </div>
      </div>
      <div className="card-meta-row">
        <StarRating
          value={rating}
          onChange={onRatingChange || (() => null)}
          readOnly={ratingReadOnly || !onRatingChange}
          size="small"
        />
      </div>
      {phoneDigits ? (
        <div className="card-meta-muted">
          <a href={`tel:${phoneDigits}`} className="btn-link">
            {formatPhoneDisplay(v.phone)}
          </a>
        </div>
      ) : (
        <div className="card-meta-muted">—</div>
      )}
      {v.email ? (
        <div className="card-meta-muted">
          <a href={`mailto:${v.email}`} className="btn-link">
            {v.email}
          </a>
        </div>
      ) : null}
      {v.notes ? <div className="panel-hint card-notes">{v.notes}</div> : null}
      {showActions ? (
        <div className="card-footer">
          <RowActionIcons variant="inline">
            {onEdit ? (
              <button type="button" onClick={onEdit} className="btn-link" style={iconBtnStyle} title="Edit">
                <IconEdit size={18} />
              </button>
            ) : null}
            {onDuplicate ? (
              <button type="button" onClick={onDuplicate} className="btn-link" style={iconBtnStyle} title="Duplicate">
                <IconDuplicate size={18} />
              </button>
            ) : null}
            {onDelete ? (
              <button type="button" onClick={onDelete} className="btn-link-danger" style={iconBtnStyle} title="Delete">
                <IconDelete size={18} />
              </button>
            ) : null}
          </RowActionIcons>
        </div>
      ) : null}
    </div>
  );
}
